<template>
  <div class="javaPage">
    <template v-if="from!='introDetail'">
        <div id="block"></div>
        <Header />
        <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />

    <pageRightFloat pageName="ILLINOIS-美国伊利诺伊理工大学"/>
    <Footer />
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    pageRightFloat,
    Header,
    Footer,
   
  },
  data() {
    return {
      flag: false,
      src: "",
      videoBtnShow: false,
      from:''
    };
  },
  mounted() {
   this.videoBtnShow = true
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
   
    close() {
      this.src = "";
      this.flag = false;
    },
    zixun(name) {
      zhuge.track("H5_美国伊利诺伊理工大学", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.javaPage {
  -webkit-overflow-scrolling:touch;
}
#block {
  width: 100%;
  height: 88px;
}
.show {
  width: 222px !important;
  .video-text {
    width: 100% !important;
  }
}
.video-float {
  transition: all 0.5s;
  position: fixed;
  right: 0;
  top: 136px;
  width: 10px;
  height: 64px;
  background: #ffffff
    linear-gradient(
      142deg,
      rgba(214, 222, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
  box-shadow: 0px 4px 24px -8px rgba(94, 123, 218, 0.4);
  border-radius: 200px 0px 0px 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 29;

  .play-btn {
    background: url("../../../assets/coursePage/java/javaPlay.png");
    width: 36px;
    height: 36px;
    background-size: cover;
    display: inline-block;
    flex-shrink: 0;
    margin: 0px 12px 0px 16px;
  }

  .video-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #273f6e;
    white-space: nowrap;

    width: 0;
    overflow: hidden;
  }
}
</style>
